<template>
  <debug-code
    :action_code_id="field.action_code_id"
    v-model:code="field.code"
  >
    <a-button
      :danger="field.danger"
      :type="field.btn_type"
      :disabled="field.disabled"
      size="small"
      @click="handlClick"
    >
      {{ field.label }}
    </a-button>
  </debug-code>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { executeScriptInWorker } from 'liyu-pc-base/utils/function';
import debugCode from '../debugCode.vue';
import { message } from 'ant-design-vue';

export default defineComponent({
  name: 'FormButton',
  components: { debugCode },
  props: {
    field: {
      type: Object,
      required: true,
    },
    modalType: {
      type: String,
      required: true,
      default: () => '',
    },
    value: {
      type: Array,
      required: true,
      default: () => [],
    },
    watch: {
      type: Array,
      default: () => [],
    },
    formModel: {
      type: Object,
      required: true,
    },
    is_form_design: {
      type: Boolean,
      default: false,
    },
    context: {
      type: Object,
      default: null,
    },
    baseKeyPath: {
      type: Array,
      default: () => [],
    },
    workerHostFunctions: {
      type: Object,
      default: () => {},
    },
  },
  emits: [],
  setup(props, { emit }) {
    const handlClick = async () => {
      if (props.field.code) {
        let res;
        try {
          res = await executeScriptInWorker(
            props.field.code,
            {
              context: props.context,
              formModel: props.formModel,
              keyPath: [...props.baseKeyPath, props.field.name],
            },
            props.workerHostFunctions || {},
          );
        } catch (e) {
          message.error(e.message);
          return;
        }
        if (res) {
          Object.assign(props.formModel, res);
        }
      }
    };
    return {
      handlClick,
    };
  },

  data() {
    return {
      model: this.value,
    };
  },
});
</script>

<style lang="less" scoped></style>
